module.exports = __webpack_public_path__ + "static/media/moreOptions.83b0f9f0.svg";